import { getRequest, postRequest } from '../../utils'
import { getQueryParamsString } from '../../utils/getQueryParamsString'
import { ShineCompanyProfile } from './types/shineCompanyProfile'
import { ShineUserProfile } from './types/shineUserProfile'

export interface InitiateShineConnectionParams {
  callback: string
  globalOrgId: string
  globalUserId: string
}

export interface InitiateShineConnectionPayload {
  organizationId: string
  params: InitiateShineConnectionParams
}

export const initiateShineConnection = ({ organizationId, params }: InitiateShineConnectionPayload) => {
  const paramsString = getQueryParamsString(params)
  return getRequest(`/shine-connect/v1/${organizationId}/product/initiate-bank-connect?${paramsString}`)
}

export interface ShineConnectionValidationPayload {
  callback: string
  code: string
  globalOrgId: string
  globalUserId: string
  state: string
}

export interface ValidateShineConnectionPayload {
  organizationId: string
  payload: ShineConnectionValidationPayload
}

export interface ProductResponse {
  globalUserId: string
  globalOrgId: string
  product: 'billy' | 'shine' | 'zervant'
}

export interface ShineConnectionResponse {
  targetProduct: ProductResponse
  sourceProduct: ProductResponse
  shineOrganization: ShineCompanyProfile
  shineUser: ShineUserProfile
  signature: string
}

export const validateShineConnection = ({
  organizationId,
  payload,
}: ValidateShineConnectionPayload): Promise<ShineConnectionResponse> => {
  return postRequest(`/shine-connect/v1/${organizationId}/product/validate-bank-connect`, payload)
}

export interface ShineConnectionMergePayload {
  targetProduct: ProductResponse
  sourceProduct: ProductResponse
  signature: string
}

export interface MergeShineAccountsPayload {
  organizationId: string
  payload: ShineConnectionMergePayload
}

export const mergeShineAccounts = ({
  organizationId,
  payload,
}: MergeShineAccountsPayload): Promise<ShineConnectionResponse> => {
  return postRequest(`/shine-connect/v1/${organizationId}/product/merge`, payload)
}
